import PropTypes from "prop-types";

// templates for prop types

export const locationShape = PropTypes.shape({
	id: PropTypes.any,
	name: PropTypes.string.isRequired,
	category: PropTypes.string.isRequired,
	pins: PropTypes.array.isRequired,
	display: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	details: PropTypes.string,
	img: PropTypes.string,
	link: PropTypes.string,
});

export const dataShape = PropTypes.arrayOf(locationShape);

export const sortedDataShape = PropTypes.objectOf(dataShape);